import React, { useEffect, useRef } from 'react'
import { ConfettiCanvas } from './Confetti.style'
import { injectStore } from '../../../store/utils'

import confetti from 'canvas-confetti'

interface OwnProps {
  setInstance: (instance: any) => void
}

type Props = OwnProps;

const Realistic: React.FC<Props> = ({ setInstance }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current) {
      setInstance(confetti.create(ref.current, {
        resize: true,
        useWorker: true,
      }))
    }
  }, [])

  return (
    <ConfettiCanvas ref={ref} />
  )
}


export default injectStore(({ confettiStore }) => ({
  setInstance: confettiStore.setInstance,
}))(Realistic)
